import { render, staticRenderFns } from "./TradeNews.vue?vue&type=template&id=08ff4acc&scoped=true&"
import script from "./TradeNews.vue?vue&type=script&lang=js&"
export * from "./TradeNews.vue?vue&type=script&lang=js&"
import style0 from "./TradeNews.vue?vue&type=style&index=0&id=08ff4acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff4acc",
  null
  
)

export default component.exports